// themes.registry.ts
import { ThemeDefinition, ThemeTypes } from './theme.types';
import { StandardSections } from './themes/standard-invoice-theme/standard-theme.sections';

export const ThemeRegistry: Record<ThemeTypes, ThemeDefinition> = {
  [ThemeTypes.StandardInvoiceTheme]: {
    id: ThemeTypes.StandardInvoiceTheme,
    title: 'Standard',
    componentLoader: () =>
      import('./themes/standard-invoice-theme/standard-invoice-theme.component').then(
        (m) => m.StandardInvoiceThemeComponent,
      ),
    sections: StandardSections,
    defaultTheme: {
      id: 1,
      themeColor: '#39a9dc',
      footerBackgroundColor: '#d8d8d8',
    },
  },
  [ThemeTypes.MinimalInvoiceTheme]: {
    id: ThemeTypes.MinimalInvoiceTheme,
    title: 'Minimal',
    componentLoader: () =>
      import('./themes/minimal-invoice-theme/minimal-invoice-theme.component').then(
        (m) => m.MinimalInvoiceThemeComponent,
      ),
    sections: /* MinimalSections */ [],
    defaultTheme: {
      id: 2,
      themeColor: '#111111',
      footerBackgroundColor: '#f2f2f2',
    },
  },
};
